import { apiSend } from "@services/axios";
import Swal from "sweetalert2";
import { isUddi } from "@global/actions";
import { notification } from "antd";
import { setData } from "@auth/Actions";
export const updtaSettingWithValidation = async (formData, extraParam) => {
  const res = await apiSend(extraParam.route, "post", formData);

  extraParam.setLoading(false);
  switch (res?.data?.request?.code) {
    default:
      messageApi(res?.data?.result?.message, "error");
      extraParam.setLoading(false);
      break;
    case 200:
      await Swal.fire({
        title: extraParam.t(extraParam.title),
        input: "text",
        inputLabel: res?.data?.result?.message,
        showCancelButton: true,
        confirmButtonText: extraParam.t("send"),
        cancelButtonText: extraParam.t("cancel"),
        showLoaderOnConfirm: true,
        preConfirm: async (value) => {
          if (isUddi(value) === false) {
            return Swal.showValidationMessage(extraParam.t("code_not_valid"));
          }
          const response = await apiSend(
            [extraParam.route, value, "validate"].join("/"),
            "get"
          );

          if (response?.data?.request?.code !== 200) {
            return Swal.showValidationMessage(extraParam.t("not_update"));
          }

          messageApi(response?.data?.result?.message);

          if (extraParam?.autorizateSetData) {
            extraParam.dispatch(setData(formData));
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
      break;
  }
};

export const messageApi = async (msg, type = "success") => {
  if (type === "error") {
    notification.error({
      message: msg,
      placement: "top",
    });
  } else {
    notification.success({
      message: msg,
      placement: "top",
    });
  }
};
